import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';

export function ThankYouPage() {
  return (
    <section className="thank-you">
      <div className="container">
        <div className="ui-card thank-you__card">
          <span className="thank-you__icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <h1 className="thank-you__title">¡Gracias! Te contactamos en menos de una hora</h1>
          <p className="thank-you__text">
            Hemos recibido tu consulta. Nos pondremos en contacto contigo en el correo o teléfono
            que nos has dejado, normalmente en menos de una hora en horario laboral.
          </p>
          <div className="thank-you__actions">
            <Link to="/">
              <Button>Volver al inicio</Button>
            </Link>
            <Link to="/caracteristicas">
              <Button variant="secondary">Ver características</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
